const verifyParameters = (parameters) => {
  let verified = true

  Object.values(parameters).forEach((value) => {
    if (value === null) {
      verified = false
    }
  })

  return verified
}

export default verifyParameters
